import './GeoArea.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import Mapir from "mapir-react-component";
import { MenuBottomGeo } from "./MenuBottomGeo";
import { mapApiKey } from "../config.json";
import { toast } from "react-toastify";

const Map = Mapir.setToken({
    hash: true,
    logoPosition: "top-left",
    //maxZoom: [16],
    transformRequest: (url) => {
        return {
            url: url,
            headers: {
                'x-api-key': `${mapApiKey}`,
                'Mapir-SDK': 'reactjs'
            }
        }

    }
});
export class GeoArea extends Component {
    static displayName = GeoArea.name;
    state = {
        showPermitModal: false,
        showSettingModal: false,

        showMap: false,
        itemSelect: {
            lat_: 35.729054,
            long_: 51.42047,
        },
        markerArray: [],
        markerArray2: [],
        points: [],

        active: false,
        setRadio: 0,
        choiceDevice: {},
    };


    reverseFunction = (map, e) => {
        var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`
        fetch(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': `${mapApiKey}`
                }
            })
            .then(response => response.json())
            .then(data => { console.log(data) });


        //console.log('ddd');
        this.setState({ geojson2: [], showMap: false });

        //------
        let array = this.state.markerArray2;
        console.log('array', array);
        let points = this.state.points;
        if (array.length >= 2) {
            array = [];
            points = [];
        }
        array.push(<Mapir.Marker
            coordinates={[e.lngLat.lng, e.lngLat.lat]}
            anchor="bottom"
        //Image={markerUrl}
        >
        </Mapir.Marker>);

        points.push({ longitude: e.lngLat.lng, latitude: e.lngLat.lat });
        console.log('pp', points);
        console.log('array', array);

        this.setState({ markerArray: array, markerArray2: array, points: points });

        if (array.length == 2) {

            let northeast = points[0];
            let southwest = points[1];
            let dd = [[
                [northeast.longitude, northeast.latitude],
                [northeast.longitude, southwest.latitude],
                [southwest.longitude, southwest.latitude],
                [southwest.longitude, northeast.latitude],
                [northeast.longitude, northeast.latitude]]];

            let geojson2 = {
                type: "FeatureCollection",
                features: [
                    {
                        type: "Feature",
                        properties: {},
                        geometry: {
                            type: "Polygon",
                            coordinates: dd,
                        }
                    }
                ]
            };
            console.log('geojson2', geojson2);
            this.setState({ geojson2: geojson2 });
        }
        this.setState({ showMap: true });
        //------
    }


    componentDidMount() {
        let choice = cardService.getChoiceCard();
        //console.log('choiceddd', choice);
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است')
            this.props.history.replace({ pathname: '/main' });
            return;
        }
        this.setState({ choiceDevice: choice });

        navigator.geolocation.getCurrentPosition(async (position) => {
            //console.log("position:", position);
            let item= this.state.itemSelect;
            item.lat_=position.coords.latitude;
            item.long_=position.coords.longitude;
            this.setState({itemSelect:item});
 

        }, async (error) => {
            toast.error('عدم دسترسی به gps');
            console.error("Error 111 = " + error.code + " - " + error.message);
        });

        /*
        let northeast = { longitude: 51.42047, latitude: 35.729054 };
        let southwest = { longitude: 52.42047, latitude: 36.729054 };
        let dd = [[
            [northeast.longitude, northeast.latitude],
            [northeast.longitude, southwest.latitude],
            [southwest.longitude, southwest.latitude],
            [southwest.longitude, northeast.latitude],
            [northeast.longitude, northeast.latitude]]];

        let geojson2 = {
            type: "FeatureCollection",
            features: [
                {
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "Polygon",
                        coordinates: dd,//[            [[-37.77367, 175.27043], [-37.77261, 175.27043],[-37.77261,175.27313],[-37.77367,175.27313]]          ]
                    }
                }
            ]
        };
        this.setState({ geojson2: geojson2,showMap:true });*/
        this.setState({ showMap: true });
        toast.dark('دو نقطه از نقشه را کلیک کنید و سپس فعال سازی را انتخاب کنید')
    }
    handleInputChange = (event) => {
        const target = event.target;
        //const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value;
        const value = target.value;

        const name = target.name;
        this.setState({ [name]: value, setRadio: 1 }, console.log('stte', this.state));
    };

    doCloseSettingModal = (e) => {
        if (this.state.setRadio == 0)
            return;
        //console.log('this.state.choiceDevice', this.state.choiceDevice);
        this.setState({ showPermitModal: false });
        //console.log('this.state.active', this.state.active);
        if (this.state.active == "false") {
            utils.sendSms(this.state.choiceDevice.deviceNumber, "region,0")
            toast.dark('لطفا تا دریافت پیام از دستگاه صبر کنید');
            return;
        }
        let array = this.state.markerArray2;
        if (array.length < 2) {
            toast.dark('دو نقطه بر روی نقشه انتخاب کرده و دوباره گزینه فعال را انتخاب کنید');
            return;
        }
        this.setState({ showSettingModal: true })
    }

    doSaveSetting = (e) => {
        e.preventDefault();
        this.setState({ showSettingModal: false })
        let points = this.state.points;
        utils.sendSms(this.state.choiceDevice.deviceNumber, `region,${points[0].latitude.toFixed(6)},${points[1].latitude.toFixed(6)},${points[0].longitude.toFixed(6)},${points[1].longitude.toFixed(6)}`)
        toast.dark('لطفا تا دریافت پیام از دستگاه صبر کنید');
    }


    getSettingModal = () => {
        return (
            <CustomModal show={this.state.showSettingModal}  >
                <div className="row">
                    <div className="col">
                        <div className="d-flex">
                            تنظیمات حصار جغرافیایی
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="d-flex">
                            آیا مایل به تنظیم حصار جغرافیایی برای دستگاه هستید؟
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">

                        <div className="d-flex">
                            <div className="p-2 flex-fill"></div>
                            <div className="p-2">
                                <button className="btn btn-dark" onClick={(e) => { this.setState({ showSettingModal: false }) }}>انصراف</button>
                            </div>
                            <div className="p-2">
                                <button className="btn btn-dark" onClick={(e) => { this.doSaveSetting(e) }}>ذخیره و ارسال</button>
                            </div>
                        </div>
                    </div>
                </div>

            </CustomModal>
        )
    }
    getPermitModal = () => {
        return (
            <CustomModal show={this.state.showPermitModal}  >
                <div className="row">
                    <div className="col">
                        <div className="d-flex">
                            تنظیمات حصار جغرافیایی
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="d-flex">
                            <div className="p-2 flex-fill">غیر فعال</div>
                            <div className="p-2">
                                <input type="radio" name="active" value="false" onChange={this.handleInputChange} checked={this.state.active == "false"} />
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="p-2 flex-fill"> فعال</div>
                            <div className="p-2">
                                <input type="radio" name="active" value="true" onChange={this.handleInputChange} checked={this.state.active == "true"} />
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="p-2 flex-fill"></div>
                            <div className="p-2">
                                <button className="btn btn-dark" onClick={(e) => { this.doCloseSettingModal(e) }}>تایید</button>
                            </div>
                        </div>
                    </div>
                </div>

            </CustomModal>
        )
    }


    render() {

        return (
            <>
                {this.getPermitModal()}
                {this.getSettingModal()}
                <div className="container-fluid1">
                    <div id="okGeoArea" onClick={(e) => this.setState({ showPermitModal: true })}>تایید حصار جغرافیایی</div>
                    <div className="row1" id="rowMap">
                        <div className="col1">
                            {this.state.showMap &&

                                <Mapir className="myMapIr"
                                    center={[this.state.itemSelect.long_, this.state.itemSelect.lat_]}
                                    Map={Map}
                                    minZoom={[13]}
                                    scrollZoom={false}
                                    hash={true}
                                    movingMethod='jumpTo'
                                    //movingMethod='jumpTo' 
                                    onClick={this.reverseFunction}>
                                    {this.state.markerArray}
                                    <Mapir.GeoJSONLayer
                                        data={this.state.geojson2}
                                        linePaint={{
                                            "line-color": "black",
                                            "line-width": 5
                                        }}
                                        fillPaint={{
                                            "fill-color": "blue",
                                            "fill-opacity": 0.2
                                        }}
                                    />
                                </Mapir>
                            }
                        </div>
                    </div>
                </div>
                <MenuBottomGeo />
            </>

        );
    }


}